<template>
    <div>
      <b-sidebar :visible="show" id="keyboard-sidebar" title="Keyboard Shortcuts" shadow>
        <template #default="{ hide }">
          <div class="px-3 py-2">
            <b-table-simple small bordered striped responsive>
              <b-thead>
                  <b-tr>
                  <b-th>Keypress</b-th>
                  <b-th>Action</b-th>
                  </b-tr>
              </b-thead>
              <b-tbody>
                <b-tr>
                  <b-td><kbd>Alt</kbd>+<kbd>K</kbd></b-td>
                  <b-td>Toggle Keyboard Shortcuts</b-td>
                </b-tr>
                <b-tr>
                  <b-td><kbd>Alt</kbd>+<kbd>R</kbd></b-td>
                  <b-td>Region Selection</b-td>
                </b-tr>
                <b-tr>
                  <b-td><kbd>Alt</kbd>+<kbd>G</kbd></b-td>
                  <b-td>Custom Group Selection</b-td>
                </b-tr>
                <b-tr>
                  <b-td><kbd>Alt</kbd>+<kbd>S</kbd></b-td>
                  <b-td>Site Selection</b-td>
                </b-tr>
                <b-tr>
                  <b-td><kbd>Alt</kbd>+<kbd>N</kbd></b-td>
                  <b-td>Next Site</b-td>
                </b-tr>
                <b-tr>
                  <b-td><kbd>Alt</kbd>+<kbd>P</kbd></b-td>
                  <b-td>Previous Site</b-td>
                </b-tr>
                <b-tr>
                  <b-td><kbd>Alt</kbd>+<kbd>Shift</kbd>+<kbd>F</kbd></b-td>
                  <b-td>Toggle between Forecast History and Calculator</b-td>
                </b-tr>
                <b-tr>
                  <b-td><kbd>Alt</kbd>+<kbd>Shift</kbd>+<kbd>R</kbd></b-td>
                  <b-td>Toggle Forecast Inventory Readings</b-td>
                </b-tr>
                <b-tr>
                  <b-td><kbd>Alt</kbd>+<kbd>I</kbd></b-td>
                  <b-td>Inventory History</b-td>
                </b-tr>
                <b-tr>
                  <b-td><kbd>Alt</kbd>+<kbd>O</kbd></b-td>
                  <b-td>Review New Order</b-td>
                </b-tr>
                <b-tr>
                  <b-td><kbd>Alt</kbd>+<kbd>C</kbd></b-td>
                  <b-td>Create Order</b-td>
                </b-tr>
                <b-tr>
                  <b-td><kbd>+</kbd></b-td>
                  <b-td>Increment Date Day</b-td>
                </b-tr>
                <b-tr>
                  <b-td><kbd>-</kbd></b-td>
                  <b-td>Decrement Date Day</b-td>
                </b-tr>
              </b-tbody>
            </b-table-simple>
            <b-button variant="kag-light-blue" block @click="hide">Close</b-button>
          </div>
        </template>
      </b-sidebar>
    </div>
  </template>

<style lang="scss" scoped>
  kbd {
      font-size: 87.5%;
      color: rgb(255, 255, 255);
      background-color: rgb(33, 37, 41);
      padding: 0.2rem 0.4rem;
      border-radius: 0.2rem;
  }

  kbd {
      font-family: SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace;
      font-size: 1em;
  }
</style>

<script>
export default {
  name: 'SiteKeyboardLegend',
  props: {
    show: Boolean
  }
}
</script>
